<template>
  <b-container fluid>
    <h3>Equipment</h3>
    <hr />
    <b-row>
      <b-col class="d-flex justify-content-start">
        <b-button variant="blue" @click="addDevice" size="sm">
          <b-icon-plus />
          Add New Model
        </b-button>
      </b-col>
    </b-row>
    <hr />
    <b-row v-if="!selectedDevice">
      <b-col :md="6">
        <b-radio-group class="mt-2" v-model="showActive">
          <b-radio :value="true">Active Models</b-radio>
          <b-radio :value="false">Inactive Models</b-radio>
        </b-radio-group>
      </b-col>
      <b-col :md="6">
        <b-form-group
          label="Category Filter:"
          :label-cols="4"
          label-align="right"
        >
          <b-select
            :options="manufacturers"
            :value="null"
            @change="onFilterSelect"
          >
            <template #first>
              <b-select-option :value="null">All</b-select-option>
            </template>
          </b-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <!-- Items Grid -->
      <b-col v-if="!selectedDevice">
        <dx-data-grid
          :data-source="models"
          :selection="gridSettings.selection"
          :allowColumnResizing="true"
          :columns="gridFields"
          :group-panel="gridSettings.groupPanel"
          :header-filter="gridSettings.headerFilter"
          :filter-row="gridSettings.filterRow"
          height="725"
          :onRowDblClick="onSelection"
          :onRowRemoving="onRemovingDevice"
          :onCellPrepared="onCellPrep"
          :editing="gridSettings.listEditing"
          :loadPanel="{ enabled: isLoading }"
          ref="grd"
        >
        </dx-data-grid>
      </b-col>
      <!-- Edit Window -->
      <b-col v-else>
        <b-overlay :show="submitting">
          <template v-slot:overlay>
            <div class="text-center">
              <b-icon-stopwatch
                font-scale="3"
                animation="cylon"
              ></b-icon-stopwatch>
              <p id="cancel-label">Saving, please wait...</p>
            </div>
          </template>
          <b-form
            :class="{
              'needs-validation': !submitted,
              'was-validated': submitted
            }"
            @submit.stop.prevent="onSubmit"
            novalidate
          >
            <b-container fluid>
              <h5>Model Information</h5>
              <b-row>
                <b-col>
                  <b-form-group
                    label="Manufacturer:"
                    :label-cols="2"
                    label-align="right"
                    label-for="man"
                  >
                    <b-form-invalid-feedback
                      :state="validationStat.manufacturer.state"
                    >
                      {{ validationStat.manufacturer.msg }}
                    </b-form-invalid-feedback>
                    <b-input
                      type="text"
                      v-model="selectedDevice.manufacturer"
                      placeholder="Please enter a manufacturer"
                      @blur="onBlur('manufacturer', $event.target)"
                      required
                      :maxlength="255"
                      autofocus
                      autocomplete="off"
                      ref="man"
                      id="man"
                    />
                  </b-form-group>
                  <b-form-group
                    label="Model Name:"
                    :label-cols="2"
                    label-align="right"
                    label-for="mod"
                  >
                    <b-input
                      type="text"
                      v-model="selectedDevice.model"
                      :maxlength="255"
                      placeholder="Model"
                      @blur="onBlur('model', $event.target)"
                      id="mod"
                      required
                      ref="mod"
                    />
                  </b-form-group>

                  <b-form-group
                    label="Status:"
                    :label-cols="2"
                    label-align="right"
                    label-for="pc"
                  >
                    <b-radio-group
                      class="mt-2"
                      v-model="selectedDevice.is_active"
                    >
                      <b-radio name="stat" :value="1">Active</b-radio>
                      <b-radio name="stat" :value="0">Inactive</b-radio>
                    </b-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr />
              <h5>Applicable items for this Model</h5>
              <b-row>
                <b-col>
                  <dx-data-grid
                    :data-source="selectedDevice.device_Model_Items"
                    :allowColumnResizing="true"
                    :columns="itemGridFields"
                    :editing="gridSettings.itemEditing"
                    :onRowRemoving="onRemovingItem"
                    :onRowUpdating="onCellPrep"
                  />
                </b-col>
              </b-row>
              <hr />
              <!-- <h5>Link Additional Items</h5>
            <b-row>
              <b-col>
                <b-form-group
                  label="Category:"
                  :label-cols="2"
                  label-align="right"
                  label-for="name"
                >
                  <b-input-group>
                    <b-select
                      :options="items"
                      v-model="selectedMerc"
                      value-field="id"
                      text-field="name"
                      ref="cat"
                    >
                      <template #first>
                        <b-select-option :value="null" disabled>
                          Choose an item to apply for this model
                        </b-select-option>
                      </template>
                    </b-select>
                    <template #append>
                      <b-button
                        :disabled="selectedMerc === null"
                        @click="addItem"
                        variant="primary"
                      >
                        Add Item
                      </b-button>
                    </template>
                  </b-input-group>
                </b-form-group>
                <span>Selected item: {{ this.selectedMerc }}</span>
              </b-col>
            </b-row> -->
              <hr />
            </b-container>
            <b-row class="mt-5">
              <b-col class="d-flex justify-content-end">
                <b-button
                  class="action-button"
                  type="submit"
                  variant="blue"
                  style="width:125px;"
                >
                  Save
                </b-button>
              </b-col>
              <b-col>
                <b-button
                  class="action-button"
                  variant="orange"
                  @click="onCancel"
                  style="width:125px;"
                >
                  Cancel
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-overlay>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// import { DxDataGrid } from "devextreme-vue/data-grid";
import { confirm } from "devextreme/ui/dialog";
import notify from "devextreme/ui/notify";
import LoadPanel from "../LoadPanel";

export default {
  components: {
    // DxDataGrid,
    LoadPanel
  },
  data() {
    return {
      selectedDevice: null,
      _status: false,
      isNewItem: false,
      isNewDevice: false,
      selectedMerc: null,
      submitted: false,
      submitting: false,
      promptUserOnCancel: false,
      validationStat: {
        manufacturer: {
          state: null,
          msg: ""
        },
        model: {
          state: null,
          msg: ""
        }
      },
      gridFields: [
        {
          dataField: "model",
          sortOrder: "asc"
        },
        {
          dataField: "manufacturer",
          // groupIndex: 0,
          // autoExpandGroup: false,
          width: 225,
          alignment: "left"
        }
      ],
      itemGridFields: [
        {
          dataField: "name",
          sortOrder: "asc"
        },
        {
          dataField: "part_number",
          width: 250
        },
        {
          dataField: "item_id",
          // groupIndex: 0,
          // autoExpandGroup: true,
          caption: "Category",
          calculateDisplayValue: this.categoryDisplay,
          width: 250,
          alignment: "left"
        }
      ],
      gridSettings: {
        selection: {
          mode: "single"
        },
        listEditing: {
          allowDeleting: true,
          useIcons: true,
          texts: {
            confirmDeleteMessage:
              "You are about to deactivate this equipment, do you wish to proceed?",
            confirmDeleteTitle: "Equipment Deactivation"
          }
        },
        itemsEditing: {
          allowAdding: false,
          allowDeleting: true,
          useIcons: true
        },
        groupPanel: {
          visible: false,
          allowColumnDragging: false
        },
        headerFilter: {
          allowSearch: true,
          visible: true
        },
        filterRow: {
          visible: true
        }
      }
    };
  },
  beforeMount() {
    return this.$store
      .dispatch("sysEquipment/getModels")
      .then(this.$store.dispatch("sysItems/loadInactive", true));
  },
  computed: {
    showActive: {
      get: function() {
        return this.$store.getters["sysEquipment/showActive"];
      },
      set: function(val) {
        // debugger;
        return this.$store
          .dispatch("sysEquipment/loadInactive", val)
          .then(() => {
            return this.$store.dispatch("sysEquipment/getModels");
          });
      }
    },
    isLoading() {
      var stat = this.$store.getters["isLoading"];
      return stat;
    },
    models() {
      if (!this.$store) {
        return [];
      }
      var itm = this.$store.getters["sysEquipment/models"];
      return itm ? itm : [];
    },
    items() {
      if (!this.$store) {
        return [];
      }

      var items = this.$store.getters["sysItems/items"];

      return items ? items : [];
    },

    categories() {
      return this.$store.getters["sysItems/categories"];
    },
    manufacturers() {
      var mans = [];
      var recs = this.models;

      // debugger;
      recs.forEach(r => {
        var m = mans.filter(mx => mx === r.manufacturer);

        if (m.length === 0) {
          mans.push(r.manufacturer);
        }
      });

      // debugger;
      mans.sort();
      return mans ? mans : [];
    }
  },
  methods: {
    onSelection(e) {
      this.selectedDevice = e.data.model ? e.data : null;
    },
    onFilterSelect(e) {
      const dg = this.$refs["grd"].instance;
      if (e === null) {
        //null = All
        dg.clearFilter();
      } else {
        debugger;
        dg.filter(["manufacturer", "=", e]);
      }
    },
    onBlur(field, e) {
      var val = this.validationStat[field];

      if (val) {
        val.state = e.checkValidity();
        val.msg = e.validationMessage;
      }
      this.trimValue();
    },
    trimValue() {
      var rec = this.selectedDevice;
      for (var prop in rec) {
        var fld = rec[prop];
        var isString = typeof rec[prop] === "string";
        if (isString) {
          rec[prop] = fld.trim();
        }
      }
    },
    addDevice() {
      this.isNewDevice = true;
      this.selectedDevice = {
        name: "",
        part_number: "",
        item_category_id: null,
        product_code: null,
        is_backordered: 0,
        backorder_date: "",
        Items: [],
        is_active: 1
      };
    },
    addItem(e) {
      debugger;
      var itm = this.selectedDevice.device_Model_Items.find(
        it => it.item_id === this.selectedMerc
      );

      if (itm) {
        return notify("Item is already linked to device!");
      }

      itm = this.items.find(i => i.id === this.selectedMerc);

      if (!itm) {
        throw "Item Not found";
        return;
      }

      debugger;
      var merc = this.items.find(it => it.id === this.selectedMerc);

      var item = {
        device_model_id: this.selectedDevice.id,
        name: merc.name,
        item_id: merc.id
      };
      debugger;
      this.selectedDevice.device_Model_Items.push(item);
      this.selectedMerc = null;
    },
    categoryDisplay(e) {
      var item = this.items.find(i => i.id === e.item_id);

      if (!item) {
        return "";
      }

      var cat = this.categories.find(c => c.id === item.item_category_id);

      if (!cat) {
        return "";
      }

      if (!cat) {
        return "";
      }

      return cat.name;
    },
    onCellPrep(e) {
      if (
        e.rowType === "data" &&
        e.column.command === "edit" &&
        e.data.is_active === 0
      ) {
        e.cellElement.hidden = true;
      }
    },
    onSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      this.submitting = true;
      //Manufacturer:
      this.validationStat.manufacturer.state = this.$refs.man.checkValidity();
      this.validationStat.manufacturer.msg = this.$refs.man.validationMessage;

      //Model:
      if (this.selectedDevice.is_backordered === 1) {
        this.validationStat.model.state = this.$refs.mod.checkValidity();
        this.validationStat.model.msg = this.$refs.mod.validationMessage;
      }

      if (!e.target.checkValidity()) {
        return;
      }

      var success = this.isNewDevice
        ? this.$store.dispatch("sysEquipment/addModel", this.selectedDevice)
        : this.$store.dispatch("sysEquipment/updateModel", this.selectedDevice);

      success.then(rsp => {
        if (!rsp) {
          return;
        }
        this.$store.dispatch("sysEquipment/getModels").then(() => {
          this.isNewDevice = false;
          this.reset();
          return;
        });
      });
    },
    onCancel(e) {
      if (this.promptUserOnCancel) {
        var msgBox = confirm(
          "<p>You have removed some linked items,  are you sure you want to cancel these changes?</p>",
          "Confirmation"
        ).then(rsp => {
          if (rsp) {
            this.reset();
          } else {
            return;
          }
        });
      } else {
        this.reset();
      }
    },
    onRemovingDevice(e) {
      return this.$store.dispatch("sysEquipment/removeModel", e.data.id);
    },
    onRemovingItem(e) {
      e.data.remove = true;
      this.promptUserOnCancel = true;

      e.cancel = true;

      var rowIndex = e.component.getRowIndexByKey(e.key);

      var $commandEditCell = e.component.getCellElement(
        rowIndex,
        "command:edit"
      );

      $commandEditCell.hidden = true;
      return;

      // if (this.isNewDevice || !e.data.id) {
      //   //Item is still not in database so we can remove it from memory.
      //   return;
      // }

      // var rsl = this.$store.dispatch(
      //   "sysEquipment/removeLinkedItem",
      //   e.data.id
      // );
      // rsl.then(rsp => {
      //   if (!rsp) {
      //     debugger;
      //     e.cancel = true;
      //     return;
      //   }

      //   return;
      // });
    },
    reset() {
      //Item Name:
      this.validationStat.manufacturer.state = null;
      this.validationStat.manufacturer.msg = "";

      //Back order:
      this.validationStat.model.state = null;
      this.validationStat.model.msg = "";

      this.submitted = false;
      this.submitting = false;
      this.isNewDevice = false;
      this.selectedDevice = null;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/admin/equipment.vue